module.exports = __webpack_public_path__ + "img/avenir-white.db5781d9.png";